module.exports = __webpack_public_path__ + "static/media/book16.6e0ba52a.jpg";